import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  TemplateRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseControlValueAccessor } from "../base_control_value_accessor/base";
import { MatAutoSearchService } from "./mat-auto-search.service";
import { debounceTime, map, startWith, Subject } from "rxjs";

@Component({
  selector: 'app-mat-auto-search',
  templateUrl: './mat-auto-search.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MatAutoSearchComponent),
    }
  ]
})
export class MatAutoSearchComponent extends BaseControlValueAccessor implements OnInit {
  @Input()
  options = [];

  _listUrl: string = null;
  @Input()
  clearSearchOnAdd: boolean = false;

  @Input()
  get listUrl(): string {
    return this._listUrl;
  }

  set listUrl(value: string) {
    this._listUrl = value;
    if (this.listUrl != null && this.isEditable) {
      this.setOptionList('');
    }
  }

  @Input()
  listUrlTransforms: Object = {};

  @Input()
  optionsPageNum = 1;

  @Input()
  optionsPageSize = 10;

  @Input()
  displayField: string = 'name';

  @Input()
  idField: string = 'id';

  @Input()
  multiple = false;

  @Input()
  setSearchValue = false;

  @Input()
  searchable: boolean = true;

  @Input()
  closeOnSelect: boolean = true;

  @Input()
  clearable = true;

  @Input()
  trim = false

  @Input()
  masterDashboard: boolean = false;

  @Input()
  masterDashboardDual: boolean = false;

  @Input()
  searchIcon: boolean = false;

  @Input()
  descriptiveLabel;

  @Input()
  secondaryLabel;

  @Output()
  change = new EventEmitter<any>();

  @Output()
  close = new EventEmitter<void>();

  searchText = new Subject<string>();
  loading = false;
  _searchText: string;

  @Input()
  removeCross: boolean = true;

  @Input()
  defaultChip: boolean = true;

  @Input()
  headerTemplate: TemplateRef<any> = null;

  @Input()
  footerTemplate: TemplateRef<any> = null;

  @Input()
  itemTemplate: TemplateRef<any> = null;

  @Input()
  labelItemTemplate: TemplateRef<any> = null;

  @Input()
  displayTemplate: TemplateRef<any> = null;

  total = 0;

  @Output()
  showAll = new EventEmitter<{ option: any[], count: number, flag: boolean }>();

  @Output()
  onMasterDashboardSearchFilterChange: EventEmitter<string> = new EventEmitter();

  masterDashboardSearchFilter: string = "depot";

  constructor(private autoSearchService: MatAutoSearchService) {
    super();
  }

  ngOnInit(): void {
    this.searchText.pipe(
      startWith(''),
      debounceTime(100),
      map(searchTerm => {
        // Commented below line because this.options should not be used with this component *USE app-select-field* instead
        // this.options = this._listUrl != null ? [] : this.options;
        this.loading = true;
        this._searchText = searchTerm;
        this.setOptionList(searchTerm);
      })
    ).subscribe();
  }

  emitChange(event) {
    console.log('emitChange', event);
    this.change.emit(event);
  }

  trackByFn(item) {
    return item[this.idField];
  }

  onClose() {
    if (this.listUrl != null) {
      this.options = [];
      this.total = 0;
    }
    this.close.emit();
  }

  triggerSearch(searchTerm) {
    this.searchText.next(searchTerm);
  }

  setOptionList(searchTerm) {

    this.loading = false;

    if (this.listUrl == null) {

      if (this.options == null) {
        console.error("No options provided");

      }

      this.loading = false;
      return;
    }

    let transforms = { ...this.listUrlTransforms }
    if (searchTerm == null) {
      searchTerm = '';
    }
    transforms['search'] = searchTerm;

    let url = new URL(this.applyUrlTransforms(this.listUrl, transforms));
    if (this.optionsPageNum != null) {
      url.searchParams.append('page', String(this.optionsPageNum));
    }
    if (this.optionsPageSize != null) {
      url.searchParams.append('page_size', String(this.optionsPageSize));
    }

    this.autoSearchService.listObjects(String(url)).subscribe((response) => {
      this.options = response.results;
      if (this.options.length == 0) {
        this.dataStatement = "No Location Found";
      }
      this.total = response.count;

      if (this.showCustom)
        this.options.unshift({
          id: 'custom',
          value: 'Others'
        });
      this.loading = false;
    });
  }

  compareField(options, idField) {
    return options === idField;
  }

  getDisplay() {
    return this.displayItem(this.data);
  }

  displayItem(item) {
    if (item == null) {
      return '-';
    }

    if (typeof item == 'object') {
      if (this.displayField in item) {
        return item[this.displayField];
      }
    } else {
      return item
    }
  }

  showAllData() {
    // this.showAll.emit({ option: this.options, count: this.total });
    this.loading = true;

    if (this.listUrl == null) {

      if (this.options == null) {
        console.error("No options provided");
      }

      this.loading = false;
      return;
    }

    let transforms = { ...this.listUrlTransforms }
    if (this._searchText == null) {
      this._searchText = '';
    }
    transforms['search'] = this._searchText;

    let url = new URL(this.applyUrlTransforms(this.listUrl, transforms));
    url.searchParams.append('page', String('1'));
    url.searchParams.append('page_size', String(this.total));
    this.autoSearchService.listObjects(String(url)).subscribe((response) => {
      this.options = response.results;
      this.total = response.count;
      this.loading = false;
      this.showAll.emit({ option: this.options, count: this.total, flag: true });
    });
  }

  masterDashboardFilterChange(event) {
    this.onMasterDashboardSearchFilterChange.emit(event)
  }

  isItemSelected(item): boolean {
    let ids = [];
    if (this.data != null) {
      this.data.map(data => ids.push(data.id));
      return ids.includes(item.id);
    }
  }
}
